export const environment = {
  production: false,
  apiUrl: 'https://dev-api-abcpack.techcrowd.space'
};
